/**
 * Traduzione italiana del catalogo di contenuti per la funzione Books & Rules / campaign
 * (`@gamecodex/world-ui` → `features/books`).
 *
 * Le chiavi rispecchiano le chiamate `t('books.*')` nei componenti React della funzione. I valori
 * sono le stringhe italiane originali estratte durante la revisione dell'i18n.
 */
export const booksIt = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': 'Reclama il tuo PDF da Sostenitore',
  'books.backerModal.sendLinkError': 'Non riusciamo a inviarti il link di accesso in questo momento. Riprova tra poco.',
  'books.backerModal.checkInboxPrefix': 'Controlla la tua inbox all\'indirizzo',
  'books.backerModal.checkInboxSuffix':
    'Se hai sostenuto il progetto con questo indirizzo, un link di accesso è in arrivo — cliccalo per reclamare la tua copia.',
  'books.backerModal.linkAutoSignIn': 'Il link si apre su questo sito e ti accede automaticamente. Nessuna password necessaria.',
  'books.backerModal.signInIntro':
    'Inserisci l\'email con cui hai sostenuto il progetto. Ti invieremo un link di accesso in un click, poi prepareremo la tua copia personale.',
  'books.backerModal.pledgeEmailLabel': 'Email dell\'account di sostegno',
  'books.backerModal.emailLinkCta': 'Inviami un link di accesso via email',
  'books.backerModal.prepareTimeout':
    'La tua copia sta impiegando più tempo del previsto per prepararsi. Riprova tra qualche minuto.',
  'books.backerModal.notEntitled': 'Sei acceduto, ma il tuo sostegno non include questo libro.',
  'books.backerModal.notClaimable': 'Questo libro non è disponibile come download per sostenitori.',
  'books.backerModal.prepareError': 'Non riusciamo a preparare il download in questo momento. Riprova tra poco.',
  'books.backerModal.signedInAs': 'Acceduto come',
  'books.backerModal.signOut': 'Esci',
  'books.backerModal.verified': 'Verificato',
  'books.backerModal.welcomeBack': ' — bentornato,',
  'books.backerModal.backerNumber': '(Sostenitore #{number})',
  'books.backerModal.copyReady':
    'La tua copia personale è pronta. Questo link è personale e scade a breve — per favore non condividerlo.',
  'books.backerModal.downloadPdf': 'Scarica il tuo PDF',
  'books.backerModal.dtrpgEmailLabel': 'Email dell\'account DriveThruRPG',
  'books.backerModal.optional': '(facoltativo)',
  'books.backerModal.dtrpgWarn':
    'Aggiungi questo per rispecchiare anche l\'acquisto nella tua libreria DriveThruRPG. Salta pure e la tua copia rimane scaricabile qui.',
  'books.backerModal.preparingCopy': 'Preparando la tua copia…',
  'books.backerModal.prepareDownload': 'Prepara & Scarica',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': 'Questo link di accesso manca del token. Richiedi un nuovo link dalla pagina del libro.',
  'books.backerVerify.invalidToken':
    'Questo link di accesso non è valido o è scaduto. Richiedi uno nuovo dalla pagina del libro.',
  'books.backerVerify.seoTitle': 'Accesso sostenitore',
  'books.backerVerify.seoDescription': 'Verifica del link di accesso sostenitore di Grymwyrd.',
  'books.backerVerify.confirming': 'Confermando il tuo accesso da sostenitore…',
  'books.backerVerify.signedInHeading': 'Sei acceduto',
  'books.backerVerify.signedInAs': 'Acceduto come',
  'books.backerVerify.headBackPrefix': 'Torna al libro e clicca',
  'books.backerVerify.downloadWord': 'Scarica',
  'books.backerVerify.headBackSuffix': 'per reclamare la tua copia.',
  'books.backerVerify.backToBook': 'Torna al tuo libro',
  'books.backerVerify.browseAthenaeum': 'Sfoglia l\'Atenaeum',
  'books.backerVerify.problemHeading': 'Problema col link di accesso',

  // BookCard.tsx
  'books.card.viewAria': 'Visualizza {title}',
  'books.card.coverAlt': 'Copertina di {title}',
  'books.card.owned': 'Posseduto',

  // BookCover.tsx
  'books.cover.coverAlt': 'Copertina di {title}',

  // BookStorePage.tsx
  'books.store.seoTitle': 'Libri e Regole',
  'books.store.seoDescription':
    'Tomi del crepuscolo eterno — manuali base, il Manuale di Riferimento illustrato, e avventure luride. Acquista per sbloccare moduli e guadagna monete.',
  'books.store.eyebrow': 'L\'Atenaeum',
  'books.store.heading': 'Libri e Regole',
  'books.store.intro':
    'Acquisisci i tomi che legano il mondo. Ogni acquisto sblocca moduli giocabili nelle tue campagne e ti gratifica con monete per l\'economia del gioco.',
  'books.store.filterAria': 'Filtra i libri per tipo',
  'books.store.filterAll': 'Tutti',
  'books.store.loading': 'Rompendo i sigilli dell\'archivio…',
  'books.store.empty': 'Nessun tomo corrisponde a questa categoria per ora. I scribi sono ancora al lavoro.',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': 'Il checkout non è ancora disponibile. Riprova presto.',
  'books.buy.signInToClaim': 'Accedi per reclamare questo tomo.',
  'books.buy.ledgerSealed': 'Il registro del mercante è sigillato per ora — il checkout arriverà presto.',
  'books.buy.inLibrary': 'Nella Tua Libreria',
  'books.buy.openingVault': 'Aprendo il caveau…',
  'books.buy.claimFree': 'Reclama Gratis',
  'books.buy.buyPrice': 'Acquista — {price}',
  'books.buy.unlockPrefix': 'Acquista → sblocca moduli +',
  'books.buy.coinsSuffix': '{coins} monete',

  // BookDetailPage.tsx
  'books.detail.loading': 'Sfogliando le pagine…',
  'books.detail.backToAthenaeum': 'Torna all\'Atenaeum',
  'books.detail.unlockOwned': 'Possiedi questo tomo — la sua tradizione di Grymwyrd è sbloccata nell\'enciclopedia.',
  'books.detail.unlockClaim': 'Reclama questo tomo per sbloccare la sua tradizione di Grymwyrd nell\'enciclopedia.',
  'books.detail.returnTo': 'Torna a {label}',
  'books.detail.backerCta': 'Sostenitore? Scarica il tuo PDF',
  'books.detail.coinsEarned': 'Hai guadagnato {coins} monete da questo acquisto.',
  'books.detail.coinsGranted': 'L\'acquisto concede {coins} monete al tuo tesoro.',
  'books.detail.byAuthor': 'Di {author}',
  'books.detail.statPrice': 'Prezzo',
  'books.detail.statPages': 'Pagine (ultimo rendering)',
  'books.detail.statWords': 'Parole (ultimo rendering)',
  'books.detail.ofThisTome': 'Di Questo Tomo',
  'books.detail.noDescription': 'Nessuna descrizione è ancora stata scritta per questo volume.',
  'books.detail.previewHeading': 'Anteprima',
  'books.detail.previewBlurb': 'Intravedere un campione di questo tomo prima di reclamarlo.',
  'books.detail.readPreview': 'Leggi un\'anteprima',
  'books.detail.tocHeading': 'Indice dei Contenuti',
  'books.detail.tocEmpty': 'Il contenuto di questo tomo non è ancora stato catalogato.',
  'books.detail.pageAbbrev': 'p. {page}',
  'books.detail.unlockedHeading': 'Voci dell\'Enciclopedia Sbloccate',
  'books.detail.unlockedOwnedNote': 'Ora parte della tua enciclopedia vivente:',
  'books.detail.unlockedLockedNote':
    'Acquista questo tomo per inscrivere le sue creature, incantesimi e segreti nella tua enciclopedia — e reclama',
  'books.detail.coinsAmount': '{coins} monete',
  'books.detail.attributionsHeading': 'Attribuzioni e Licenze',
  'books.detail.attributionSource': 'Fonte',
  'books.detail.attributionLink': 'collegamento',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': 'Campagna in Diretta',
  'books.campaign.backThisProject': 'Sostieni Questo Progetto',
  'books.campaign.viewStretchGoals': 'Vedi gli Obiettivi Aggiuntivi',
  'books.campaign.pledged': 'Promesso',
  'books.campaign.backers': 'Sostenitori',
  'books.campaign.pitchHeading': 'La Proposta',
  'books.campaign.backerUnlockedHeading': 'Voci Sbloccate dai Sostenitori',
  'books.campaign.backerUnlockedBlurb':
    'I sostenitori ottengono accesso anticipato ai contenuti che confluiscono direttamente nell\'enciclopedia vivente. Ecco un assaggio di quello che è già canone:',
  'books.campaign.previewsEmpty': 'Un nuovo canone è in fase di iscrizione — torna qui quando gli obiettivi si sbloccheranno.',
  'books.campaign.choosePledge': 'Scegli il Tuo Impegno',
  'books.campaign.mostBacked': 'Più Sostenuto',
  'books.campaign.pledgeAmount': 'Prometti {amount}',
  'books.campaign.pledgeFooter':
    'Gli impegni vengono elaborati in sicurezza al checkout. I premi per il sostegno (monete, moduli e sblocchi dell\'enciclopedia) vengono concessi al tuo account Grymwyrd una volta che il servizio di campagna entra in funzione.',

  // LanguageSelect.tsx
  'books.language.label': 'Lingua',

  // PreviewModal.tsx
  'books.preview.title': 'Anteprima — {title}',
  'books.preview.pdfAria': 'Anteprima PDF di {title}',
  'books.preview.cannotDisplay': 'Il tuo evocatore non riesce a visualizzare l\'anteprima inline.',
  'books.preview.openNewTab': 'Apri l\'anteprima in una nuova scheda',
  'books.preview.preparingHeading': 'L\'anteprima è in preparazione.',
  'books.preview.preparingBody':
    'Un campione di questo tomo viene riscritto dallo scriptorium e apparirà qui tra poco. Nel frattempo, intravedere cosa giace all\'interno:',
  'books.preview.excerptLabel': 'Estratto — {title}',
  'books.preview.excerptFallback':
    'Oltre questa soglia si estendono pagine intrise di terrore e meraviglia. Acquisisci il tomo per leggere oltre.',
  'books.preview.noExcerpt': 'Nessun estratto è ancora stato catalogato per questo volume.',

  // RulesPage.tsx
  'books.rules.sectionSpells': 'Incantesimi',
  'books.rules.sectionMonsters': 'Mostri',
  'books.rules.sectionMagicItems': 'Oggetti Magici',
  'books.rules.sectionWeapons': 'Armi',
  'books.rules.sectionArmor': 'Armature',
  'books.rules.sectionSkills': 'Abilità',
  'books.rules.entriesCount': '{entries} voci',
  'books.rules.readingLabel': 'Leggendo {label}…',
  'books.rules.noneCatalogued': 'Nessun {label} catalogato in questo sistema ancora.',
  'books.rules.browseAll': 'Sfoglia tutti i {label} nell\'enciclopedia →',
  'books.rules.seoTitle': 'Regole e Manuale di Riferimento',
  'books.rules.seoDescription':
    'Sfoglia il Manuale di Riferimento del Sistema — incantesimi, mostri, oggetti e le regole che legano il crepuscolo eterno. 5e SRD adesso, con altri sistemi in arrivo.',
  'books.rules.eyebrow': 'Il Codice',
  'books.rules.heading': 'Regole e Manuale di Riferimento del Sistema',
  'books.rules.intro':
    'Il contenuto di gioco aperto che alimenta Grymwyrd. Sfoglia voci rilevanti alle regole e immergiti nell\'enciclopedia completa per blocchi di statistiche e tradizione. Grymwyrd viene fornito con il 5e SRD oggi — PF2e e altri sistemi sono in arrivo.',
  'books.rules.loading': 'Consultando il codice…',
  'books.rules.gameSystems': 'Sistemi di Gioco',
  'books.rules.noSystems': 'Nessun sistema di gioco è ancora registrato.',
  'books.rules.openSrd': 'Apri Manuale di Riferimento',
  'books.rules.lockedComingSoon': 'Bloccato — presto disponibile',
  'books.rules.referenceContent': '{name} — Contenuto di Riferimento',
  'books.rules.releasedUnder': 'Rilasciato sotto {license}',
  'books.rules.licenseLink': 'licenza',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': 'Progresso di finanziamento di {title}',
  'books.stretch.unlockedAdded': 'Sbloccato — aggiunto all\'enciclopedia',
  'books.stretch.percentFunded': '{pct}% finanziato',
  'books.stretch.autoPopulates': 'Popola automaticamente l\'enciclopedia',
  'books.stretch.raisedSoFar': 'Raccolto finora',
  'books.stretch.backers': 'Sostenitori',
  'books.stretch.overallAria': 'Finanziamento complessivo della campagna',
  'books.stretch.heading': 'Obiettivi Aggiuntivi',
} as const
